export default __webpack_public_path__ + "static/media/google.2eec9b0f.svg";